import { useQuery } from '@tanstack/react-query';
import supabaseClient from '@/api/supabaseClient.ts';
import type { Tables } from '$/database.types';

export type AdminOrg = Pick<Tables<'organizations'>, 'id' | 'name' | 'created_at'> & {
  user_count: number;
  decision_count: number;
  avg_governance_score: number | null;
  pending_escalations: number;
  credits_remaining: Tables<'credits'>['credits_remaining'];
  credits_purchased: Tables<'credits'>['credits_purchased'];
};

async function fetchAdminOrganizations(): Promise<AdminOrg[]> {
  const { data, error } = await supabaseClient.functions.invoke('admin-organizations', {
    method: 'GET',
  });

  if (error) throw new Error(error.message ?? 'Failed to fetch organizations');
  return (data?.data ?? []) as AdminOrg[];
}

const useAdminOrganizations = () =>
  useQuery({
    queryKey: ['admin-organizations'],
    queryFn: fetchAdminOrganizations,
  });

export default useAdminOrganizations;
